import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ApiRequestService, TranslationPipe } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { Material } from '../shared/material.model';
import { ProductsResponse } from '../shared/products.response';
import { GetPressArticleResponse } from './getpresarticleresponse';
import { GetPressArticleRequest } from './getpressarticlerequest';
import { PressArticle } from './pressarticle';
import { GetPressArticleUseCase } from './usecase/get-pressarticle-usecase';

@Component({
    selector: 'pf-pressarticle',
    templateUrl: './pressarticle.component.html',
    styleUrls: ['./pressarticle.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslationPipe]
})
export class PressarticleComponent implements OnInit {
    downloadFileUrl = '';
    getPressArticleForAProductResponse?: GetPressArticleResponse = {};
    getPressArticleForAProductUrl = '/store/get-pressarticlesforaproduct';

    getProductsUrl = '/store/get-products';
    id = 0;
    materials: Material[] = [];
    pressArticleList?: PressArticle[] = [];
    pressArticleUrl = '';
    productId = 0;
    productResponse: ProductsResponse = {};
    storeBackendUrl = '';

    constructor(
        private _getPressarticleUseCase: GetPressArticleUseCase,
        private _apiRequestService: ApiRequestService,
        @Inject('STORE_BACKEND_URL') _storeBackendUrl: string,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string
    ) {
        this.storeBackendUrl = _storeBackendUrl;
        this.downloadFileUrl = _downloadFileUrl;
        this.pressArticleUrl = this.downloadFileUrl + '/pressarticleicon';
    }

    ngOnInit(): void {
        this._apiRequestService.sendRequest(this.storeBackendUrl, {}, true, this.getProductsUrl).subscribe((productList) => {
            this.productResponse = productList as ProductsResponse;
            this.materials = this.productResponse.productList as Material[];
            const lastSegmentOfUrl = window.location.href.split('/').pop();
            this.materials.forEach((material) => {
                if (lastSegmentOfUrl!.includes(material.routerLink as string)) {
                    this.productId = material.id!;
                }
            });
            const getPressArticleForAProductRequest: GetPressArticleRequest = {
                productId: this.productId
            };

            // this._apiRequestService
            //     .sendRequest(this.storeBackendUrl, true, getPressArticleForAProductRequest, true, this.getPressArticleForAProductUrl)
            (this._getPressarticleUseCase.execute(getPressArticleForAProductRequest) as Observable<GetPressArticleResponse>).subscribe(
                (answer) => {
                    this.getPressArticleForAProductResponse = answer;
                    this.pressArticleList = this.getPressArticleForAProductResponse.pressArticleList;
                }
            );
        });
    }

    //TODO call url: "/store/get-pressarticlesforaproduct" to get pressarticles from store
}
